export const countryOrderType = {
  Default: "default",
  Random: "random",
  Infinite: "infinite",
};
